import Highcharts from '../highcharts'
import resetIcon from '/../assets/highcharts/reset.svg'
import barChartIcon from '/../assets/highcharts/chart-bar.svg'
import outliersIcon from '/../assets/highcharts/outliers.png'
import { PCT_Y_AXIS_ID } from './constants'

export const STOCKTOOLS_JGP_INDICATORS = 'jgp-indicators'
export const STOCKTOOLS_JGP_CHANGE_LINE_TO_COLUMN = 'jgp-change-line-to-column'
export const STOCKTOOLS_JGP_CHANGE_COLUMN_TO_LINE = 'jgp-change-column-to-line'
export const STOCKTOOLS_JGP_OUTLIERS = 'jgp-outliers'
export const STOCKTOOLS_JGP_RESET = 'jgp-reset'

export const hideStockToolsOnLoad: Highcharts.Options = {
  chart: {
    events: {
      load: function () {
        // @ts-ignore
        this.stockTools.showhideBtn?.click()
      },
    },
  },
}

export const dragZoomXAxis: Highcharts.Options = {
  chart: {
    zooming: { type: 'x' },
  },
}

export const dragZoomXYAxis: Highcharts.Options = {
  chart: {
    zooming: { type: 'xy' },
  },
}

export const jgpCredits: Highcharts.Options = {
  credits: {
    href: 'https://www.jgp.com.br',
    text: 'Fonte: JGP',
  },
}

export const enableLegend: Highcharts.Options = {
  legend: {
    enabled: true,
  },
}

export const hideNavigator: Highcharts.Options = {
  navigator: {
    enabled: false,
  },
}

export const scrollbarLiveRedraw: Highcharts.Options = {
  scrollbar: {
    liveRedraw: true,
  },
}

export const pctYAxis: Highcharts.Options = {
  yAxis: [
    {
      id: PCT_Y_AXIS_ID,
      title: { text: '%' },
      opposite: true,
      showEmpty: false,
    },
  ],
}

export const stockTools = (
  enabled: boolean,
  chartId: string
): Highcharts.Options =>
  enabled
    ? {
        stockTools: {
          gui: {
            enabled,
          },
        },
        navigation: {
          bindingsClassName: chartId,
        },
      }
    : { stockTools: { gui: { enabled: false } } }

export const stockToolsIndicators: Highcharts.Options = {
  lang: {
    stockTools: {
      gui: {
        jgpIndicators: 'Indicadores',
      } as Highcharts.LangStockToolsGuiOptions,
    },
  },
  stockTools: {
    gui: {
      buttons: ['jgpIndicators'],
      definitions: {
        jgpIndicators: {
          className: STOCKTOOLS_JGP_INDICATORS,
          symbol: 'indicators.svg',
        },
      } as Highcharts.StockToolsGuiDefinitionsOptions,
    },
  },
  navigation: {
    bindings: {
      jgpIndicators: {
        className: STOCKTOOLS_JGP_INDICATORS,
      },
    },
  },
}

export const stockToolsChangeLineColumn: Highcharts.Options = {
  lang: {
    stockTools: {
      gui: {
        jgpChangeLineColumn: 'Mudar tipo de gráfico',
        jgpChangeLineToColumn: 'Mudar gráfico linha para barra',
        jgpChangeColumnToLine: 'Mudar gráfico barra para linha',
      } as Highcharts.LangStockToolsGuiOptions,
    },
  },
  stockTools: {
    gui: {
      buttons: ['jgpChangeLineColumn'],
      definitions: {
        jgpChangeLineColumn: {
          items: ['jgpChangeLineToColumn', 'jgpChangeColumnToLine'],
          jgpChangeLineToColumn: {
            className: STOCKTOOLS_JGP_CHANGE_LINE_TO_COLUMN,
            symbol: '"', // invalid path so it uses our custom css instead
          },
          jgpChangeColumnToLine: {
            className: STOCKTOOLS_JGP_CHANGE_COLUMN_TO_LINE,
            symbol: 'series-line.svg',
          },
        },
      } as Highcharts.StockToolsGuiDefinitionsOptions,
    },
  },
  navigation: {
    bindings: {
      jgpChangeLineToColumn: {
        className: STOCKTOOLS_JGP_CHANGE_LINE_TO_COLUMN,
      },
      jgpChangeColumnToLine: {
        className: STOCKTOOLS_JGP_CHANGE_COLUMN_TO_LINE,
      },
    },
  },
}

export const stockToolsOutliers: Highcharts.Options = {
  lang: {
    stockTools: {
      gui: {
        jgpOutliers: 'Remover pontos',
      } as Highcharts.LangStockToolsGuiOptions,
    },
  },
  stockTools: {
    gui: {
      buttons: ['jgpOutliers'],
      definitions: {
        jgpOutliers: {
          className: STOCKTOOLS_JGP_OUTLIERS,
          symbol: '"',
        },
      } as Highcharts.StockToolsGuiDefinitionsOptions,
    },
  },
  navigation: {
    bindings: {
      jgpOutliers: {
        className: STOCKTOOLS_JGP_OUTLIERS,
      },
    },
  },
}

export const stockToolsReset: Highcharts.Options = {
  lang: {
    stockTools: {
      gui: {
        jgpReset: 'Resetar mudanças',
      } as Highcharts.LangStockToolsGuiOptions,
    },
  },
  stockTools: {
    gui: {
      buttons: ['jgpReset'],
      definitions: {
        jgpReset: {
          className: STOCKTOOLS_JGP_RESET,
          symbol: '"',
        },
      } as Highcharts.StockToolsGuiDefinitionsOptions,
    },
  },
  navigation: {
    bindings: {
      jgpReset: {
        className: STOCKTOOLS_JGP_RESET,
      },
    },
  },
}

export const selectablePoints: Highcharts.Options = {
  plotOptions: {
    series: {
      allowPointSelect: true,
      point: {
        events: {
          select: function () {
            this.update({
              marker: {
                radius: 4,
                enabled: true,
              },
            })
          },
          unselect: function () {
            this.update({
              marker: {
                enabled: false,
              },
            })
          },
        },
      },
    },
  },
}

export const disableDataGrouping: Highcharts.Options = {
  plotOptions: {
    column: {
      dataGrouping: {
        enabled: false,
      },
    },
    line: {
      dataGrouping: {
        enabled: false,
      },
    },
  },
}

export const initializeDisabledScrollbar: Highcharts.Options = {
  scrollbar: {
    enabled: false,
    showFull: false,
  },
}

// This is the default for Stockchart, but not for regular chart
export const hideHighchartsTitle: Highcharts.Options = {
  title: {
    text: undefined,
  },
}

// This is the default for Stockchart, but not for regular chart
export const enableSplitTooltip: Highcharts.Options = {
  tooltip: {
    split: true,
  },
}

// Prevents charts with large data from crashing when using
// the implemented features
export const disableTurbo: Highcharts.Options = {
  plotOptions: {
    series: {
      turboThreshold: 0,
    },
  },
}

export const addCustomCss = () => {
  const customStocktoolsButtonsCss = `
.${STOCKTOOLS_JGP_RESET} > .highcharts-menu-item-btn {
  background-image: url("${resetIcon}");
}

.${STOCKTOOLS_JGP_CHANGE_LINE_TO_COLUMN} > .highcharts-menu-item-btn {
  background-image: url("${barChartIcon}");
}

.${STOCKTOOLS_JGP_OUTLIERS} > .highcharts-menu-item-btn {
  background-image: url("${outliersIcon}");
  background-size: cover;
}
`
  const stockToolsToggleButtonCss = `
.highcharts-toggle-toolbar {
  height: 1.5rem;
  width: 1.5rem;
}
`

  const style = document.createElement('style')
  style.type = 'text/css'
  style.appendChild(
    document.createTextNode(
      [customStocktoolsButtonsCss, stockToolsToggleButtonCss].join('')
    )
  )
  document.head.appendChild(style)
}
